import { useState } from "react";
import Marquee from "react-fast-marquee";

// PLST session photos — real coaching in action.
// Numbered strictly by upload filename (1..9). Missing images will simply not render.
const AVAILABLE = [1, 2, 3, 4, 5];  // extend as more images arrive

export default function SessionStrip() {
  const [paused, setPaused] = useState(false);
  return (
    <section
      className="bg-[#F5F4EF] py-8 lg:py-12 border-y border-[#1E1E1E]/10"
      data-testid="session-strip"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onTouchStart={() => setPaused(true)}
      onTouchEnd={() => setPaused(false)}
    >
      <Marquee gradient={false} speed={22} pauseOnHover pauseOnClick play={!paused}>
        <div className="flex items-stretch gap-4 lg:gap-6 pr-4 lg:pr-6">
          {[...AVAILABLE, ...AVAILABLE].map((n, i) => (
            <div
              key={`${n}-${i}`}
              className="shrink-0 h-[240px] sm:h-[280px] lg:h-[360px] overflow-hidden bg-[#222]"
              data-testid={`session-${n}`}
            >
              <img
                src={`/media/sessions/${n}.webp`}
                alt=""
                loading="lazy"
                className="h-full w-auto object-cover block"
                draggable={false}
              />
            </div>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
